/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import clsx from 'clsx';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import useDashboard from '../../../../hooks/useDashboard';

/* Modal */
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import useStyles from '../../Main.style';

const HistoricPerformanceTable = ({ cellHistoricTableDataFromMyCell }) => {
  /* Modal */
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const enableReinitializeValue = true;

  const [cellHistoricTableData, setCellHistoricTableData] = useState([]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { getCellHistoricTable } = useDashboard();
  const [selectedCellValue, setSelectedCellValue] = useState(loggedInUserData?.cell?.cellValue);
  const [selectedCountryValue, setSelectedCountryValue] = useState(
    loggedInUserData?.country?.countryValue,
  );

  const loadCellHistoricTable = async () => {
    const myCellWorkLoadList = cellHistoricTableDataFromMyCell;
    setCellHistoricTableData(myCellWorkLoadList?.userResult || []);
  };

  useEffect(() => {
    loadCellHistoricTable();
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  const classes = useStyles();
  return (
    <>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="center"
        className={classes.container}
      >
        <Grid container>
          <Box width={1} p={1.5}>
            <Grid container spacing={4}>
              <Grid item xs={12} /* className={classes.innercontent} */>
                {/* <Box mt={2} /> */}

                <Grid container spacing={3}>
                  <Box className={classes.GraphTableDetail} width="100%">
                    <MaterialTable
                      style={{ boxShadow: 'none' }}
                      className={classes.materialDT}
                      options={{
                        toolbar: false,
                        draggable: false,
                        paging: false,
                        sorting: true,
                        pageSize: 20,
                        pageSizeOptions: [10, 20, 50, 100],
                        showTextRowsSelected: false,
                        toolbarButtonAlignment: 'right',
                        showFirstLastPageButtons: false,
                        actionsColumnIndex: -100,
                        emptyRowsWhenPaging: false,
                      }}
                      localization={{
                        pagination: {
                          labelRowsSelect: 'Rows',
                          labelRowsPerPage: 'Rows Per Page',
                        },
                      }}
                      title="Summary Dashboard/Personal Performance"
                      columns={[
                        {
                          title: 'Metric',
                          field: 'metric',
                        },
                        {
                          title: 'My Cell',
                          field: 'myCell',
                          render: (data) => (
                            <>
                              <Box display="flex">
                                <Box>{data?.myCell}</Box>
                                {/* <Box className={classes.TableLightText}>/ Client</Box> */}
                              </Box>
                            </>
                          ),
                        },
                        {
                          title: 'Ranking',
                          field: 'ranking',
                          render: (data) => (
                            <span className={classes.vectorranking}>{data?.ranking}</span>
                          ),
                        },
                        {
                          title: 'Top Cell',
                          field: 'topCell',
                          render: (data) => (
                            <>
                              <Box display="flex">
                                <Box>{data?.topCell}</Box>
                                {/* <Box className={classes.TableLightText}>/ Client</Box> */}
                              </Box>
                            </>
                          ),
                        },
                        {
                          title: 'Vector Average',
                          field: 'vctorAverage',
                          render: (data) => (
                            <>
                              <Box display="flex">
                                <Box>{data?.vctorAverage}</Box>
                                {/* <Box className={classes.TableLightText}>/ Client</Box> */}
                              </Box>
                            </>
                          ),
                        },
                      ]}
                      data={cellHistoricTableData || []}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default HistoricPerformanceTable;
